import React from "react";

function CookiesPanel({ cookies }) {
  if (!cookies || cookies.length === 0) {
    return (
      <div className="p-4 text-center text-gray-500 text-sm">
        No cookies returned in this response
      </div>
    );
  }

  return (
    <div className="border border-gray-200 rounded-md overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="text-left px-3 py-2 font-medium text-gray-600 border-b border-gray-200">
              Name
            </th>
            <th className="text-left px-3 py-2 font-medium text-gray-600 border-b border-gray-200">
              Value
            </th>
            <th className="text-left px-3 py-2 font-medium text-gray-600 border-b border-gray-200">
              Domain
            </th>
            <th className="text-left px-3 py-2 font-medium text-gray-600 border-b border-gray-200">
              Path
            </th>
            <th className="text-left px-3 py-2 font-medium text-gray-600 border-b border-gray-200">
              Expires
            </th>
            <th className="text-left px-3 py-2 font-medium text-gray-600 border-b border-gray-200">
              Secure
            </th>
            <th className="text-left px-3 py-2 font-medium text-gray-600 border-b border-gray-200">
              HttpOnly
            </th>
          </tr>
        </thead>
        <tbody>
          {cookies.map((cookie, index) => (
            <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}>
              <td className="px-3 py-2 font-mono text-xs text-gray-900 border-b border-gray-100">
                {cookie.name}
              </td>
              <td className="px-3 py-2 font-mono text-xs text-gray-900 border-b border-gray-100 break-all">
                {cookie.value}
              </td>
              <td className="px-3 py-2 text-xs text-gray-600 border-b border-gray-100">
                {cookie.domain || "-"}
              </td>
              <td className="px-3 py-2 text-xs text-gray-600 border-b border-gray-100">
                {cookie.path || "-"}
              </td>
              <td className="px-3 py-2 text-xs text-gray-600 border-b border-gray-100">
                {cookie.expires || cookie.maxAge || "Session"}
              </td>
              <td className="px-3 py-2 text-xs border-b border-gray-100">
                {cookie.secure ? "✓" : "-"}
              </td>
              <td className="px-3 py-2 text-xs border-b border-gray-100">
                {cookie.httpOnly ? "✓" : "-"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default CookiesPanel;
